import { render, staticRenderFns } from "./OrderCalendar.vue?vue&type=template&id=589c3a18&"
import script from "./OrderCalendar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrderCalendar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OrderCalendar.vue?vue&type=style&index=0&id=589c3a18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports